import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Exercicios } from '@/features/exercicios/componentes/Exercicios';
import { rotaDeTela } from '@/features/permissoes/guardas';

const id = z.uuid().optional().catch(undefined);
const busca = z.object({
  busca: z.string().optional().catch(undefined),
  equipamentoId: id,
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_autenticado/exercicios/')({
  ...rotaDeTela('exercicios.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const filtros = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Exercicios
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
